import moment from 'moment';
import 'moment/locale/uk';

moment.locale('uk');
moment.updateLocale('uk', {
  calendar: {
    lastDay: '[вчора] LT',
    sameDay: 'LT',
    lastWeek: 'ddd LT',
    sameElse: 'DD MMM LT'
  }
});

export const formatDate = date => {
  return moment(+date).calendar();
};
